import { groupBy } from "ramda";

import { type DocumentSet } from "@hsl/core/documents/types";

export const groupByDocType = groupBy((docSet: DocumentSet) =>
    docSet.lit_type_id.toString(),
);
